import Model from '@models/Model'

class Country extends Model {
  constructor (initialData, included) {
    super(initialData, included, {
      columns: [
        'id',
        'name',
        'active',
        'restricted',
        'currency',
        'discarded_at',
        'created_at',
        'updated_at',
      ],
      dateKeys: [
        'discarded_at',
        'created_at',
        'updated_at',
      ],
      relationships: {},
    })
  }
}

export default Country
